module.exports = __webpack_public_path__ + "img/Image 4.3a9dbe33.png";